export interface NavbarConfig {
  title: string;
  icon?: string;
  routerLink?: any;
}
